import React, {useEffect, useState} from "react";
import {Grid} from "@mui/material";
import MsgError from "../../../components/MsgError";
import HeaderPage from "../../../components/Admin/HeaderPage";
import Table from "../../../components/Table";
import {apiInstall} from "../../../services/Admin/doc";
import pjson from "../../../../package.json";

export default function DocInstall() {
    const [rows, setRows] = useState([])
    const [msgError, setMsgError] = useState([])
    const [loading, setLoading] = useState(true)
    const [rowCount, setRowCount] = useState(0)
    const [state, setState] = useState(initialValues)

    const pjson = require("../../../../package.json")

    useEffect(() => {
        getItemsData()
    }, [state])

    const getItemsData = () => {
        setLoading(true)
        setMsgError([])

        apiInstall().then(resp => {

            const api = Object.keys(resp.data).map((key) => {
                return {type: "symfony", name: key, version: resp.data[key]}
            })

            // convert json to array
            const dependencies = Object.keys(pjson.dependencies).map((key) => {
                return {type: "react", name: key, version: pjson.dependencies[key]}
            })

            const devDependencies = Object.keys(pjson.devDependencies).map((key) => {
                return {type: "react", name: key, version: pjson.devDependencies[key]}
            })

            // Unir dos arrays
            const allDependencies = [...dependencies, ...devDependencies, ...api]
            setRows(allDependencies)
            setLoading(false)
        }).catch(err => {
            setMsgError(err.response?.data?.msg)
            setLoading(false)
            setRows([])
        })
    }

    return (
        <>
            <HeaderPage title="Librerías" />

            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <MsgError msg={msgError}/>
                </Grid>

                <Grid item xs={12}>
                    <Table
                        columns={tableColumns()}
                        rows={rows}
                        rowCount={null}
                        filter={state}
                        setFilter={setState}
                        loading={loading}
                    />
                </Grid>
            </Grid>
        </>
    );
}

function initialValues(props) {
    return {
        offset: 0,
        sort: { field: "id", sort: "desc" },
        email: "",
        role: ""
    }
}

function tableColumns(handleChangeSelection, selection) {
    return [
        {
            field: "type",
            headerName: "TIPO",
            sortable: false,
            flex: 1
        },
        {
            field: "name",
            headerName: "NOMBRE",
            sortable: false,
            flex: 1
        },
        {
            field: "version",
            headerName: "VERSIÓN",
            sortable: false,
            flex: 1
        },
    ]
}
